import {
    FormControl,
    Select as RawSelect,
    styled,
    MenuItem,
    InputLabel,
} from '@mui/material'
import {paramCase} from 'change-case'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'
import {useI18n, useIsRtl} from 'store/Store'

const Select = ({
    itemName,
    name,
    label,
    dataTestId,
    multiline,
    required,
    InputProps,
    options,
    height,
    width,
    containerStyle,
    selectStyle,
    placeholder,
    format,
    ...p
}) => {
    const {i18n} = useI18n()
    const isRTL = useIsRtl()

    return (
        <Container style={containerStyle}>
            {label && <Label required={required}>{label}</Label>}
            <StyledFormControl {...p} style={{width}}>
                <StyledSelect
                    {...p}
                    fullWidth
                    height={height}
                    hiddenLabel
                    disableUnderline
                    variant="outlined"
                    multiline={multiline}
                    data-test-id={`input-${paramCase(
                        label || dataTestId || 'undefined'
                    )}`}
                    InputProps={{
                        ...InputProps,
                    }}
                    IconComponent={KeyboardArrowDownIcon}
                    style={selectStyle}>
                    {options.map((option) => (
                        <MenuItem
                            key={option}
                            value={option}
                            style={{direction: isRTL ? 'rtl' : 'ltr'}}>
                            {format
                                ? option
                                : i18n.t(`${itemName}.${name}s.${option}`)}
                        </MenuItem>
                    ))}
                </StyledSelect>
            </StyledFormControl>
        </Container>
    )
}

export default Select
const Container = styled('div')`
    width: 100%;
`

const StyledSelect = styled(RawSelect)`
    background: white;
    &.MuiInputBase-root {
        height: ${({height}) => height || '35px'};
        padding-inline: 8px;
    }

    & .MuiOutlinesInput-root {
        height: ${({height}) => height || '35px'};
        padding: 0;
    }

    & .MuiSelect-select {
        padding-right: 0 !important;
    }
    & svg {
        position: unset;
    }
`

const Label = styled(InputLabel)`
    top: -8px;
`
const StyledFormControl = styled(FormControl)`
    height: ${({height}) => height || '35px'};
`
